// Port of api/fuel/app/classes/model/game/mechanic.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_mechanic',
	prefix: '',
	key: 'game_mechanic_id',
	fields: {
		game_mechanic_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		mechanic_id: Model.SCHEMA_NUMBER
	}
})
